import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PartnersSection } from '../components/PartnersSection';
import { Wine, Sparkles, Heart } from 'lucide-react';
export function AboutPage() {
  return <div className="min-h-screen bg-white" data-id="element-528">
      {/* Header */}
      <Header variant="light" data-id="element-529" />

      {/* Hero Section */}
      <section className="relative min-h-[80vh] overflow-hidden pt-32" data-id="element-530">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/0Y4A1449-Guy-Dixon.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-531" />
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-532" />

        {/* Content */}
        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-533">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-534" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-535">
            Our Story
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-536">
            About Us
          </h1>
          <p className="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto" data-id="element-537">
            A family legacy of sparkling wine excellence in the heart of the
            Hunter Valley
          </p>
        </div>
      </section>

      {/* Our Wines - Ian Peterson's Story */}
      <section className="bg-white py-20 px-8" data-id="element-538">
        <div className="max-w-7xl mx-auto" data-id="element-539">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-540">
            {/* Content */}
            <div className="space-y-6 order-1" data-id="element-541">
              <div className="space-y-3" data-id="element-542">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-543"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-544">
                  Our Beginning
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-545">
                  Our Wines
                </h2>
              </div>
              <div className="space-y-4" data-id="element-546">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-547">
                  Peterson House was born from the vision of Ian Peterson, who,
                  in his early years felt it necessary to celebrate each
                  grandchild's birth with a special wine. When his first grand
                  daughter was born, he thought it fitting to produce his own
                  sparkling wine, however soon discovered that no-one in NSW was
                  commercially producing sparkling wine in small volumes.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-548">
                  So Mr. Peterson leaped across the borders to South Australia
                  to have his sparkling wine made; in what was the beginning of
                  a journey of bubbles.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2" data-id="element-549">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-wine-wall.jpg" alt="Peterson House vineyard" className="w-full h-full object-cover" data-id="element-550" />
            </div>
          </div>
        </div>
      </section>

      {/* Colin Peterson Quote Section */}
      <section className="bg-neutral-100 py-20 px-8" data-id="element-551">
        <div className="max-w-4xl mx-auto" data-id="element-552">
          <div className="bg-white border border-neutral-200 rounded-none p-8 md:p-12" data-id="element-553">
            <div className="flex justify-center mb-6" data-id="element-554">
              <Sparkles className="w-12 h-12 text-brand-pink opacity-20" data-id="element-555" />
            </div>
            <blockquote className="text-center" data-id="element-556">
              <p className="text-xl text-neutral-700 mb-6 leading-relaxed italic" data-id="element-557">
                "Watching Peterson House grow into the iconic place it is today
                is extremely close to my heart. My father, Ian Peterson had a
                vision; to produce traditional method sparkling wine and to
                enjoy this wine with friends and family. Now, nearly two decades
                on, we have kept this vision alive with Peterson House being the
                hub of sparkling wine in the Hunter Valley."
              </p>
              <footer className="text-center" data-id="element-558">
                <p className="text-base font-medium text-neutral-900" data-id="element-559">
                  Colin Peterson
                </p>
                <p className="text-sm text-neutral-500" data-id="element-560">Peterson House</p>
              </footer>
            </blockquote>
          </div>
        </div>
      </section>

      {/* Current Vision Section */}
      <section className="bg-white py-20 px-8" data-id="element-561">
        <div className="max-w-7xl mx-auto" data-id="element-562">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-563">
            {/* Content */}
            <div className="space-y-6 order-1 lg:order-1" data-id="element-564">
              <div className="space-y-3" data-id="element-565">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-566"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-567">
                  Today
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-568">
                  The Hub of Sparkling Wine
                </h2>
              </div>
              <div className="space-y-4" data-id="element-569">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-570">
                  Nowadays, the iconic building of Peterson House is a
                  specialist producer of sparkling wines in the Hunter Valley
                  Wineries. Our aim is to have a wine for all tastes and all
                  occasions, because as we say here:
                </p>
                <p className="text-brand-pink text-2xl font-serif italic" data-id="element-571">
                  Life's flat without bubbles!
                </p>
              </div>

              {/* Feature Icons */}
              <div className="grid grid-cols-3 gap-6 pt-6" data-id="element-572">
                <div className="text-center" data-id="element-573">
                  <div className="flex justify-center mb-3" data-id="element-574">
                    <div className="w-12 h-12 bg-brand-pink/10 rounded-full flex items-center justify-center" data-id="element-575">
                      <Wine className="w-6 h-6 text-brand-pink" data-id="element-576" />
                    </div>
                  </div>
                  <p className="text-sm text-neutral-600 font-medium" data-id="element-577">
                    30+ Varieties
                  </p>
                </div>
                <div className="text-center" data-id="element-578">
                  <div className="flex justify-center mb-3" data-id="element-579">
                    <div className="w-12 h-12 bg-brand-pink/10 rounded-full flex items-center justify-center" data-id="element-580">
                      <Sparkles className="w-6 h-6 text-brand-pink" data-id="element-581" />
                    </div>
                  </div>
                  <p className="text-sm text-neutral-600 font-medium" data-id="element-582">
                    Traditional Method
                  </p>
                </div>
                <div className="text-center" data-id="element-583">
                  <div className="flex justify-center mb-3" data-id="element-584">
                    <div className="w-12 h-12 bg-brand-pink/10 rounded-full flex items-center justify-center" data-id="element-585">
                      <Heart className="w-6 h-6 text-brand-pink" data-id="element-586" />
                    </div>
                  </div>
                  <p className="text-sm text-neutral-600 font-medium" data-id="element-587">
                    Family Legacy
                  </p>
                </div>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-2" data-id="element-588">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Sparkling-Wine-About-Us.jpg" alt="Peterson House building" className="w-full h-full object-cover" data-id="element-589" />
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <PartnersSection data-id="element-590" />

      {/* Footer */}
      <Footer data-id="element-591" />
    </div>;
}